import { render, staticRenderFns } from "./creator.vue?vue&type=template&id=1fb6845a&scoped=true"
import script from "./creator.vue?vue&type=script&lang=js"
export * from "./creator.vue?vue&type=script&lang=js"
import style0 from "./creator.vue?vue&type=style&index=0&id=1fb6845a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb6845a",
  null
  
)

export default component.exports